import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

import { InputField } from "../../../../shared/ui/input-field/input-field";
import { Button } from "../../../../shared/ui/button/button";
import { SingleFileUpload } from "../../../../shared/components/single-file-upload/single-file-upload";
import { DatePicker } from "../../../../shared/components/date-picker/date-picker";
import { dateFormatValidator, fileValidator } from '../../../../shared/utils/functions';
import { CustomDropdown } from "../../../../shared/components/custom-dropdown/custom-dropdown";
import { countries, governate, licenseIssuer } from '../../../../shared/utils/data';
import { Sidebar } from '../../../../core/services/sidebar';


@Component({
  selector: 'app-step2-license-details',
  imports: [InputField, Button, SingleFileUpload, DatePicker, TranslatePipe, ReactiveFormsModule, CustomDropdown],
  templateUrl: './step2-license-details.html',
  styleUrl: './step2-license-details.css'
})
export class Step2LicenseDetails implements OnInit {
  @Input() data: any;
  @Input() onboardingStep!: number;
  @Input() onboardingSubStep!: number;
  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();

  countriesOptions = countries;
  governateOptions = governate;
  licenseIssuerOptions = licenseIssuer;

  tradeLicenseDetailsForm = new FormGroup({
    tradeName: new FormControl('', [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(100)
    ]),

    countryOfRegistration: new FormControl('', [Validators.required]),

    licenseNumber: new FormControl('', [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(100),
      Validators.pattern(/^[A-Za-z0-9-]+$/)
    ]),

    licenseExpiryDate: new FormControl(null, [
      Validators.required,
      dateFormatValidator
    ]),

    certificateOfRegistration: new FormControl('', [
      Validators.required,
      fileValidator(['jpg', 'png', 'pdf', 'doc'], 5)
    ]),

    governate: new FormControl('', [Validators.required]),
    tradeingLicenseIssuer: new FormControl('', [Validators.required]),

    tradingLiscenseNumber: new FormControl('', [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(100)
    ]),

    tradingLiscenseIssuingDate: new FormControl(null, [
      Validators.required,
      dateFormatValidator
    ]),

    tradingCertificate: new FormControl('', [
      Validators.required,
      fileValidator(['jpg', 'png', 'pdf', 'doc'], 5)
    ])
  })

  constructor(private sidebarService: Sidebar) {

  }

  ngOnInit(): void {
    this.sidebarService.setLinks([
      { label: 'SIDEBAR.PREVIOUS_SCREEN', action: () => this.goBackStep(), iconPath: 'assets/icons/arrow-blue.svg', variant: 'outlined' },
      { label: 'SIDEBAR.SAVE_EXIT', route: '/', iconPath: 'assets/icons/cancel-blue.svg', variant: 'plain' }
    ]);
  }

  onFileSelected(file: File, controlName: string) {
    // console.log('File selected:', file);
    this.tradeLicenseDetailsForm.get(controlName)?.setValue(file);
  }

  onFileRemoved(controlName: string) {
    // console.log('Removed file for:', controlName);
    this.tradeLicenseDetailsForm.get(controlName)?.reset();
  }

  onDropdownSelect(controlName: string, selectedItem: any) {
    this.tradeLicenseDetailsForm.get(controlName)?.setValue(selectedItem.label);
  }

  handleFormSubmission() {
    // console.log('Form submitted!', this.tradeLicenseDetailsForm.value);
    this.next.emit();
  }

  getControl(controlName: string): FormControl {
    return this.tradeLicenseDetailsForm.get(controlName) as FormControl;
  }

  /** Go back to Company registration */
  goBackStep() {
    this.prev.emit();
  }
}
